import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import { withRouter } from 'react-router-dom'
import routes from '../../router/routes'
import BackIcon from '@material-ui/icons/ArrowBack'
import { strings } from '../../../localization/strings'
import { platforms } from '../../../server/shared'
import News from '../news/news'

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
}

class Component extends React.Component {
    config = {}

    state = {
        anchorEl: null,
    }

    handleMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    }
    handleChangePassword = () => {
        this.handleClose()
        this.props.history.push(routes.changePassword.path)
    }
    handleLogOut = () => {
        this.handleClose()
        this.props.handleLogOut(this.props.history)
    }

    render() {
        this.config = Object.values(routes).filter(
            (route) =>
                route.path.toLowerCase() ===
                this.props.history.location.pathname.toLowerCase()
        )[0]
        if (!this.config) this.config = {}
        if (!this.config.toolbar) this.config.toolbar = {}

        return (
            <div className={this.props.classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        {this.showBackButton()}
                        {this.showDrawerButton()}
                        {this.showTitle()}
                        {this.showNewsButton()}
                        {this.showProfileButton()}
                    </Toolbar>
                </AppBar>
            </div>
        )
    }

    showDrawerButton = () => {
        if (!this.props.toggleDrawer) return null
        if (!this.config.toolbar.drawerButton) return null
        return (
            <IconButton
                onClick={this.props.toggleDrawer(true)}
                className={this.props.classes.menuButton}
                color="inherit"
                aria-label="Menu"
            >
                <MenuIcon />
            </IconButton>
        )
    }

    showTitle = () => {
        let showOk = this.config.toolbar.titleLabel !== false;
        if (!showOk) return null;
        return (
            <Typography
                variant="h6"
                color="inherit"
                className={this.props.classes.grow}
            >
                {this.config.title}{' '}
                {this.props.shop ? ' - ' + this.props.shop : null}
            </Typography>
        )
    }

    showProfileButton = () => {
        let authOk = this.props.authenticated===true;
        let showOk = this.config.toolbar.profileButton;
        let platformOk = !!this.props.platform && this.props.platform !== platforms.shopify;
        if (!authOk || !showOk || !platformOk) return null;

        const { anchorEl } = this.state
        const open = Boolean(anchorEl)
        return (
            <div>
                <IconButton
                    aria-owns={open ? 'menu-appbar' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    getContentAnchorEl={null}
                    transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                    }}
                    open={open}
                    onClose={this.handleClose}
                >
                    <MenuItem onClick={this.handleChangePassword}>
                        {strings.toolbarChangePasswordButton}
                    </MenuItem>
                    <MenuItem onClick={this.handleLogOut}>
                        {strings.toolbarLogOutButton}
                    </MenuItem>
                </Menu>
            </div>
        )
    }

    showNewsButton = () => {
        let authOk = this.props.authenticated===true;
        let showOk = this.config.toolbar.newsButton;
        if (!authOk || !showOk) return null;
        return <News/>;
    }

    showBackButton = () => {
        let showOk = this.config.toolbar.backButton;
        if (!showOk) return null;
        return <IconButton
                onClick={() => this.props.history.goBack()}
                color="inherit"
                aria-label="Menu"
            >
                <BackIcon />
            </IconButton>
    }
}

Component.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(withRouter(Component))



